module.exports = __webpack_public_path__ + "static/images/edit-pencil-outline.46e889119566b12ee3fd64cc3998c8bc.svg";